import { render, staticRenderFns } from "./QOpcionUnica.vue?vue&type=template&id=108add36"
import script from "./QOpcionUnica.vue?vue&type=script&lang=js"
export * from "./QOpcionUnica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports